import React from "react";
import styles from "./signAndLock.module.scss";

export const SignedBadge = ({ locked }) => (
  <span className={styles.signed}>
    <span className={styles.signned_sign}></span>
    Signed {locked && "& Locked"}
  </span>
);
